module.exports = __webpack_public_path__ + "static/media/female-customer-luggers-loading.e3772bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/female-customer-luggers-loading.png
// module id = 1169
// module chunks = 27